import { Menu } from 'antd';
import styled from 'styled-components';

export default styled(Menu)`
	// Add your styles here
`;
